import { templateLiveRadioCard, templateNextRadioCard } from "./cards";
import { audioPlayer, handlerSound } from "./audioPlayer";

// Variables globales para el sistema de cron
let cronInterval = null;
let nextProgramTimestamp = null;
let currentProgramData = null;

const fetchRadio = () => {
  fetch(tdea_ajax.ajax_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      action: "get_live_radio",
      nonce: tdea_ajax.nonce,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        let dataRadio = data.data;
        let program = dataRadio.programa_actual.data;

        // Guardar datos del programa actual
        currentProgramData = dataRadio;

        const container = document.getElementById("radio-container");
        audioPlayer(program, dataRadio.programa_actual.horario);
        if (container) {
          if (dataRadio.programa_actual) {
            container.innerHTML = templateLiveRadioCard(program);

            const playLiveButton = document.querySelector(".live-card__button");
            playLiveButton.addEventListener("click", () => {
              handlerSound();
            });
          }
          if (dataRadio.a_continuacion) {
            const continueProgram =
              document.querySelector("#continue-programs");
            let programs = dataRadio.a_continuacion.data;
            continueProgram.innerHTML = templateNextRadioCard(
              programs,
              dataRadio.a_continuacion.horario
            );

            // Guardar timestamp del próximo programa
            nextProgramTimestamp =
              dataRadio.a_continuacion.horario.timestamp_inicio;
          }
          if (dataRadio.siguiente_programa) {
            const nextProgram = document.querySelector("#next-program");
            let programs = dataRadio.siguiente_programa.data;
            nextProgram.innerHTML = templateNextRadioCard(
              programs,
              dataRadio.siguiente_programa.horario,
              "Más tarde"
            );
          }
        }

        // Iniciar sistema de cron para cambio automático
        initProgramScheduler(dataRadio);
      } else {
      }
    })
    .catch((error) => {});
};

// Sistema de cron para cambio automático de contenido
const initProgramScheduler = (dataRadio) => {
  // Limpiar intervalo anterior si existe
  if (cronInterval) {
    clearInterval(cronInterval);
  }

  // Verificar cada 10 segundos si es hora de cambiar de programa
  cronInterval = setInterval(() => {
    checkAndSwitchProgram(dataRadio);
  }, 10000); // 10 segundos

  // También verificar inmediatamente
  checkAndSwitchProgram(dataRadio);
};

const checkAndSwitchProgram = (dataRadio) => {
  const now = Math.floor(Date.now() / 1000); // Timestamp actual en segundos

  // Verificar si hay un programa "a continuación" programado
  if (
    dataRadio.a_continuacion &&
    dataRadio.a_continuacion.horario.timestamp_inicio
  ) {
    const nextStart = dataRadio.a_continuacion.horario.timestamp_inicio;

    // Si ya pasó la hora de inicio del siguiente programa (con margen de 30 segundos)
    if (now >= nextStart && now < nextStart + 30) {
      console.log("⏰ Hora de cambiar al siguiente programa programado");
      switchToScheduledProgram();
    }
  }

  // Verificar si hay un "siguiente programa" que deba empezar
  if (
    dataRadio.siguiente_programa &&
    dataRadio.siguiente_programa.horario.timestamp_inicio
  ) {
    const nextStart = dataRadio.siguiente_programa.horario.timestamp_inicio;

    if (now >= nextStart && now < nextStart + 30) {
      console.log("⏰ Hora de cambiar al siguiente programa programado");
      switchToScheduledProgram();
    }
  }
};

const switchToScheduledProgram = () => {
  console.log("🔄 Cambiando a contenido programado...");

  // Recargar la parrilla completa para obtener el nuevo programa actual
  fetchRadio();
};

// Exportar como función global para que pueda ser llamada desde audioPlayer
window.reloadRadioSchedule = fetchRadio;

export default fetchRadio;
